import ExploreMerchant from './ExploreMerchant';
import MerchantCategory from './MerchantCategory';

export default class ExploreTopcontent {
  public readonly newMerchants: ExploreMerchant[];
  public readonly popularMerchants: ExploreMerchant[];
  public readonly recentlyBookedMerchants: ExploreMerchant[];
  public readonly primaryCategories: MerchantCategory[];

  constructor(init: ExploreTopcontentInitializer) {
    this.newMerchants = init.newMerchants.map(
      merchants => new ExploreMerchant({ ...merchants }),
    );
    this.popularMerchants = init.popularMerchants.map(
      merchants => new ExploreMerchant({ ...merchants }),
    );
    this.recentlyBookedMerchants = init.recentlyBookedMerchants.map(
      merchants => new ExploreMerchant({ ...merchants }),
    );
    this.primaryCategories = init.primaryCategories.map(
      category => new MerchantCategory({ ...category }),
    );
  }
}

export interface ExploreTopcontentInitializer {
  newMerchants: ExploreMerchant[];
  popularMerchants: ExploreMerchant[];
  recentlyBookedMerchants: ExploreMerchant[];
  primaryCategories: MerchantCategory[];
}
